import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store';

// EN-10064 — derive Set lookups for the lobby once per restriction change, so
// each tile can test membership in O(1) without rebuilding a Set per render.

const selectRestrictions = (state: RootState) => state.colluderRestrictions.restrictions;

export const selectRestrictedCashIds = createSelector(
  selectRestrictions,
  (r) => new Set(r.restrictedCash)
);

export const selectRestrictedTexasCGIds = createSelector(
  selectRestrictions,
  (r) => new Set(r.restrictedTexasCG)
);

export const selectRestrictedOmahaCGIds = createSelector(
  selectRestrictions,
  (r) => new Set(r.restrictedOmahaCG)
);

export const selectRestrictedSngIds = createSelector(
  selectRestrictions,
  (r) => new Set(r.restrictedSng)
);

export const selectRestrictedMttIds = createSelector(
  selectRestrictions,
  (r) => new Set(r.restrictedMtt)
);

export const selectIntegrityBlock = (state: RootState) => state.colluderRestrictions.block;
